(function () {
  if (window.__provinceCheckoutReady) return;
  window.__provinceCheckoutReady = true;

  var CHECKOUT_SELECTOR =
    '#checkout, [data-province-checkout], [name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';

  var SCOPE_SELECTOR = '[data-checkout-address]';
  var COUNTRY_SELECTOR = '[data-checkout-country]';
  var PROVINCE_SELECTOR = '[data-province-select]';

  // Order matters: first invalid field in this order gets focus.
  var FIELD_ORDER = ['address1', 'city', 'country', 'province', 'postal_code'];

  var ALLOWED_COUNTRIES = { CA: true, US: true };

  var POSTAL_RULES = {
    CA: {
      pattern: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
      normalize: function (v) {
        var s = v.replace(/[\s-]/g, '').toUpperCase();
        return s.length === 6 ? s.slice(0, 3) + ' ' + s.slice(3) : s;
      },
      message: 'Please enter a valid Canadian postal code (e.g. A1A 1A1).'
    },
    US: {
      pattern: /^\d{5}(-?\d{4})?$/,
      normalize: function (v) {
        var s = v.replace(/\s/g, '');
        return /^\d{9}$/.test(s) ? s.slice(0, 5) + '-' + s.slice(5) : s;
      },
      message: 'Please enter a valid ZIP code (e.g. 12345 or 12345-6789).'
    }
  };

  var busy = false;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- Scope / field lookup ---------- */

  function findScope(trigger) {
    var scoped = trigger && trigger.closest ? trigger.closest(SCOPE_SELECTOR) : null;
    if (scoped) return scoped;

    // The cart page and the drawer can both be in the DOM. Prefer a visible one.
    var all = document.querySelectorAll(SCOPE_SELECTOR);
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) return all[i];
    }
    return all[0] || null;
  }

  function getFields(scope) {
    var fields = {};
    FIELD_ORDER.forEach(function (key) {
      fields[key] = scope.querySelector('[data-checkout-field="' + key + '"]');
    });
    return fields;
  }

  /* ---------- Country -> province filtering ---------- */

  function syncProvinces(scope) {
    if (!scope) return;
    var country = scope.querySelector(COUNTRY_SELECTOR);
    var province = scope.querySelector(PROVINCE_SELECTOR);
    if (!country || !province) return;

    var code = country.value;

    province.querySelectorAll('optgroup[data-country]').forEach(function (group) {
      var match = group.getAttribute('data-country') === code;
      group.disabled = !match;
      group.hidden = !match;
    });

    province.disabled = !code;

    // Clear a province that belongs to the other country.
    var selected = province.selectedOptions && province.selectedOptions[0];
    var group = selected && selected.parentElement;
    if (group && group.tagName === 'OPTGROUP' && group.getAttribute('data-country') !== code) {
      province.value = '';
    }

    // Apply the prefilled province once, if it fits the chosen country.
    var def = province.getAttribute('data-default');
    if (!province.value && def && code) {
      var opt = province.querySelector('optgroup[data-country="' + code + '"] option[value="' + def + '"]');
      if (opt) province.value = def;
      province.removeAttribute('data-default');
    }
  }

  function syncAll() {
    document.querySelectorAll(SCOPE_SELECTOR).forEach(syncProvinces);
  }

  /* ---------- Validation ---------- */

  function validate(scope) {
    var fields = getFields(scope);

    for (var i = 0; i < FIELD_ORDER.length; i++) {
      if (!fields[FIELD_ORDER[i]]) {
        console.error('Checkout address field missing:', FIELD_ORDER[i]);
        return null;
      }
    }

    syncProvinces(scope);

    // Trim text inputs so whitespace-only values fail `required`.
    ['address1', 'city', 'postal_code'].forEach(function (key) {
      fields[key].value = fields[key].value.trim();
    });

    var country = fields.country.value;
    var postal = fields.postal_code;
    postal.setCustomValidity('');

    if (country && !ALLOWED_COUNTRIES[country]) {
      fields.country.setCustomValidity('Please select Canada or United States.');
    } else {
      fields.country.setCustomValidity('');
    }

    var rule = POSTAL_RULES[country];
    if (rule && postal.value) {
      if (rule.pattern.test(postal.value)) {
        postal.value = rule.normalize(postal.value);
      } else {
        postal.setCustomValidity(rule.message);
      }
    }

    for (var j = 0; j < FIELD_ORDER.length; j++) {
      var el = fields[FIELD_ORDER[j]];

      // A disabled select is skipped by native validation, so check province manually.
      var missingProvince = FIELD_ORDER[j] === 'province' && !el.value;

      if (missingProvince || !el.checkValidity()) {
        el.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (missingProvince && el.disabled) {
          fields.country.focus();
        } else {
          el.reportValidity();
          el.focus();
        }
        return null;
      }
    }

    return {
      address1: fields.address1.value,
      city: fields.city.value,
      province: fields.province.value,
      country: country,
      postal_code: postal.value
    };
  }

  /* ---------- Button state ---------- */

  function setLoading(btn, isLoading) {
    busy = isLoading;
    if (!btn) return;

    if (isLoading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.dataset.originalText = btn.innerHTML;
      btn.innerHTML = '<span class="button-text">Processing...</span>';
    } else {
      if (btn.dataset.originalText) {
        btn.innerHTML = btn.dataset.originalText;
        delete btn.dataset.originalText;
      }
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  /* ---------- Checkout ---------- */

  function startCheckout(trigger) {
    if (busy) return;

    var scope = findScope(trigger);

    // A checkout link outside the cart has no address form; send them to the cart.
    if (!scope) {
      window.location.href = routeRoot() + 'cart';
      return;
    }

    var address = validate(scope);
    if (!address) return;

    var btn = trigger && trigger.tagName === 'BUTTON' ? trigger : null;
    setLoading(btn, true);

    fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load cart');
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) throw new Error('Cart is empty');

        return fetch('/apps/api/draft-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            currency_code: cart.currency || 'CAD',
            address: address.address1,
            city: address.city,
            province: address.province,
            country: address.country,
            postal: address.postal_code,
            items: cart.items.map(function (item) {
              return {
                variant_id: item.variant_id.toString(),
                quantity: item.quantity
              };
            })
          })
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.message || 'Error processing draft order.');
          return data;
        });
      })
      .then(function (data) {
        if (!data.invoice_url) throw new Error('Invoice URL missing from response');
        window.location.href = data.invoice_url;
      })
      .catch(function (err) {
        console.error('Draft order checkout failed:', err);
        setLoading(btn, false);
        alert('We could not process your checkout request. Please try again.');
      });
  }

  /* ---------- Event wiring (delegated, so drawer re-renders are covered) ---------- */

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches(COUNTRY_SELECTOR)) {
      e.target.setCustomValidity('');
      syncProvinces(e.target.closest(SCOPE_SELECTOR));
    }
  });

  // Re-sync right before the province list opens, in case the markup was re-rendered.
  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches(PROVINCE_SELECTOR)) {
      syncProvinces(e.target.closest(SCOPE_SELECTOR));
    }
  });

  // Clear the postal-code error as soon as the customer edits it.
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-checkout-field="postal_code"]')) {
      e.target.setCustomValidity('');
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest ? e.target.closest(CHECKOUT_SELECTOR) : null;
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      startCheckout(trigger);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var submitter = e.submitter;
      if (!submitter || !submitter.closest) return;
      if (!submitter.closest(CHECKOUT_SELECTOR)) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      startCheckout(submitter);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  window.provinceCheckout = startCheckout;
})();